import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpm6a59phn: FaireProductEntity = {
  token: "p_gpm6a59phn",
  type: "product",
  name: "Trikona - Neon orange - 100% organic cotton throw blanket",
  brandToken: "b_4h2n9rlls5",
  brandName: "Pink Lemonade",
  imageUrl:
    "https://cdn.faire.com/fastly/a3fd7b166d237a78cdf0b3643b91806d8def57a1609112cff55d20d35c148e48.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bfbd4c802e854cec85ff17d39d7ed15eb642649e77b447b084649bdd59123a9.jpeg",
    "https://cdn.faire.com/fastly/a17a5cddd5f33a7ed2564239436a21aa151e22d68ea4e053dceeeb202c86798f.jpeg",
  ],
  priceDollars: 60,
  description:
    "Elevate your space with our Geometric Cotton Throw Blanket, a vibrant fusion of modern luxury and unique style. Crafted from organic cotton with a textured, thick-and-thin knit, it combines softness with durability. Featuring a bold color palette and funky geometric patterns, this blanket adds a contemporary flair to any space, making it a standout piece in your home decor.\n\n𝐀𝐛𝐨𝐮𝐭:\n\n• 50 X 60 inches\n• Organic Combed Cotton\n• AZO Free\n• OEKO TEX Certified\n• GOTS Certified\n• Made in India\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Low Iron\n• Do Not Bleach\n• Lay Flat To Dry\n• Do Not Line Dry\n• Do Not Dry Clean\n• Do Not Tumble Dry\n• Reshape When Damp\n• Delicate Machine Wash At 30 Degrees",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:58.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
